import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaArrowLeft, FaArrowRight, FaDownload } from "react-icons/fa";
import "../styles/CertificadosCarousel.css";
import certificacionesData from "../data/certificacionesData";
import Swal from "sweetalert2";
import {
  trackCourseDownload,
  trackCourseMoreInfoClick,
  trackWhatsAppClick,
} from "../utils/analytics";

const whatsappNumber = "5579118589";

const getCourseSlug = (nombreCurso) => {
  if (nombreCurso.includes("EC0616")) {
    return "certificacion-ec0616";
  }
  if (nombreCurso.includes("Podolog")) {
    return "diplomado-podologia-clinica-ixtapaluca";
  }
  if (nombreCurso.includes("Fisioterapia")) {
    return "curso-fisioterapia-ixtapaluca";
  }
  if (nombreCurso.includes("Auxiliar")) {
    return "curso-auxiliar-enfermeria-ixtapaluca";
  }
  if (nombreCurso.includes("Quiro")) {
    return "diplomado-quiropractica-ixtapaluca";
  }
  if (nombreCurso.includes("Masajes")) {
    return "curso-masoterapia-ixtapaluca";
  }
  if (nombreCurso.includes("EC")) {
    return "certificaciones-sep-estado-de-mexico";
  }
  return null;
};

const CertificadosCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [cardsToShow, setCardsToShow] = useState(2);

  const handleWhatsApp = (nombreCurso) => {
    Swal.fire({
      title: "Abriremos WhatsApp",
      text: `Te brindaremos más información sobre ${nombreCurso} sin compromiso. Nuestro objetivo en Fundación Nican es ayudarte a tomar la mejor decisión para tu desarrollo profesional.`,
      icon: "info",
      confirmButtonText: "Aceptar",
      confirmButtonColor: "var(--primary-color)",
    }).then((result) => {
      if (result.isConfirmed) {
        trackWhatsAppClick("carousel_certificados", {
          course_name: nombreCurso,
        });
        const message = `¡Hola! Estoy interesado/a en recibir información sobre ${nombreCurso}. ¿Podrías ayudarme con los detalles?`;
        const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
          message
        )}`;
        window.open(url, "_blank", "noopener,noreferrer");
      }
    });
  };

  useEffect(() => {
    const updateCardsToShow = () => {
      setCardsToShow(window.innerWidth < 768 ? 1 : 2);
    };
    window.addEventListener("resize", updateCardsToShow);
    updateCardsToShow();
    return () => window.removeEventListener("resize", updateCardsToShow);
  }, []);

  const nextSlide = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex + cardsToShow) % certificacionesData.length
    );
  };

  const prevSlide = () => {
    setCurrentIndex(
      (prevIndex) =>
        (prevIndex - cardsToShow + certificacionesData.length) %
        certificacionesData.length
    );
  };

  return (
    <div
      className="container carousel-container"
      data-aos="fade-right"
      id="certificaciones"
    >
      <div className="row text-center my-4">
        <h2>Conoce nuestras Certificaciones y Diplomados</h2>
      </div>

      <div className="row carousel">
        <div className="col-1 p-0 m-0">
          <button className="carousel-button prev" onClick={prevSlide}>
            <FaArrowLeft />
          </button>
        </div>

        <div className="carousel-cards col-10">
          <div className="row justify-content-center">
            {certificacionesData
              .slice(currentIndex, currentIndex + cardsToShow)
              .map((cert, idx) => {
                const courseSlug = getCourseSlug(cert.nombre);

                return (
                  <div key={idx} className="card mx-3 p-0">
                    <h3
                      className={`card-header ${
                        idx % 2 === 0 ? "header-primary" : "header-secondary"
                      }`}
                    >
                      {cert.nombre}
                    </h3>

                    <img
                      src={
                        cert.imagen
                          ? require(`../imgs/certificados/${cert.imagen}`)
                          : "https://marketplace.canva.com/EAFQNGff-B8/1/0/1600w/canva-certificado-de-reconocimiento-simple-azul-y-amarillo-jVqupEcSv7g.jpg"
                      }
                      alt={cert.nombre}
                      className="certificado-image"
                    />

                    <div className="card-body overflow-auto">
                      <p>
                        <strong>Beneficios</strong>
                      </p>
                      <p className="text-justify">{cert.beneficios}</p>

                      {courseSlug && (
                        <Link
                          to={`/${courseSlug}`}
                          className="btn btn-link p-0 d-block mx-auto text-decoration-underline conocer-mas-link"
                          onClick={() =>
                            trackCourseMoreInfoClick(
                              cert.nombre,
                              "carousel_certificados"
                            )
                          }
                        >
                          Ver detalles del programa
                        </Link>
                      )}
                      <button
                        type="button"
                        onClick={() => handleWhatsApp(cert.nombre)}
                        className="btn btn-link p-0 d-block mx-auto text-decoration-underline conocer-mas-link"
                      >
                        Solicita más información sin compromiso
                      </button>
                    </div>

                    <div className="card-footer d-flex justify-content-between">
                      <div className="footer-left">{cert.nombre}</div>
                      {cert.descargable && (
                        <div className="footer-right">
                          <FaDownload
                            onClick={() => {
                              trackCourseDownload(
                                cert.nombre,
                                cert.descargable,
                                "carousel_certificados"
                              );
                              const link = document.createElement("a");
                              link.href = require(`../data/Informacion/${cert.descargable}`);
                              link.download = cert.descargable;
                              link.click();
                            }}
                            style={{ cursor: "pointer" }}
                            title="Descargar información"
                            aria-label="Descargar información del curso"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>

        <div className="col-1 p-0 m-0 Card-Button-P">
          <button className="carousel-button next" onClick={nextSlide}>
            <FaArrowRight />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CertificadosCarousel;
